import { render, staticRenderFns } from "./QueueEdit.vue?vue&type=template&id=fb787898&"
import script from "./QueueEdit.vue?vue&type=script&lang=js&"
export * from "./QueueEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports